import { useLazyQuery } from '@apollo/client';
import { GET_EVALUATION_IDEA_IDS, Idea } from '@frontend/data-access';
import {
  EvaluateIdeasCompleted,
  EvaluateIdeasPending,
  selectChannelFilters,
} from '@frontend/feature-idea-channel';
import { Spin, Tabs } from 'antd';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../channel-store/settings/hooks';
import useTranslation from 'next-translate/useTranslation';

import styles from './evaluate-ideas.module.less';

/* eslint-disable-next-line */
export interface EvaluateIdeasProps {}

export function EvaluateIdeas(props: EvaluateIdeasProps) {
  const { t } = useTranslation('common');
  const router = useRouter();
  const { ideaId } = router.query;
  const [tab, setTab] = useState<string>();
  const [pendingIdeas, setPendingIdeas] = useState<string[]>([]);
  const channelFilters = useAppSelector(selectChannelFilters);
  const [
    getCompletedCount,
    { data: completedData, loading: completedLoading },
  ] = useLazyQuery<{
    listEvaluationIdeas: {
      items: Idea[];
      total: number;
    };
  }>(GET_EVALUATION_IDEA_IDS, {
    fetchPolicy: 'network-only',
  });
  const [getPending, { data: pendingData, loading: pendingLoading }] =
    useLazyQuery<{
      listEvaluationIdeas: {
        items: {
          id: string;
        }[];
        total: number;
      };
    }>(GET_EVALUATION_IDEA_IDS, {
      fetchPolicy: 'network-only',
    });
  const pendingTotal = pendingData?.listEvaluationIdeas.total || 0;
  const completedTotal = completedData?.listEvaluationIdeas.total || 0;

  useEffect(() => {
    setPendingIdeas(
      pendingData?.listEvaluationIdeas.items.map((i) => i.id) || []
    );
  }, [pendingData]);

  useEffect(() => {
    getCompletedCount({
      variables: {
        filterBy: {
          ...channelFilters,
        },
        isEvaluated: true,
        page: 1,
        limit: 1,
      },
    });
    getPending({
      variables: {
        filterBy: {
          ...channelFilters,
        },
        isEvaluated: false,
        page: 1,
        limit: 9999,
      },
    });
  }, [channelFilters, getCompletedCount, getPending]);

  useEffect(() => {
    if (!pendingIdeas.includes(ideaId as string) && ideaId) {
      router.push({
        query: {
          ideaId: pendingIdeas[0],
        },
      });
    }
  }, [ideaId, pendingIdeas, router]);

  if (completedLoading || pendingLoading) {
    return (
      <div className="p-5 text-center">
        <Spin />
      </div>
    );
  }
  return (
    <div className={styles['container']}>
      <Tabs
        activeKey={tab}
        onChange={(value) => setTab(value)}
        items={[
          {
            key: 'pending',
            label: t('pending_ideas', { count: pendingTotal }),
            children: <EvaluateIdeasPending ideaIds={pendingIdeas} />,
          },
          {
            key: 'completed',
            label: t('completed_ideas', { count: completedTotal }),
            children: <EvaluateIdeasCompleted total={completedTotal} />,
          },
        ]}
      />
    </div>
  );
}

export default EvaluateIdeas;
